import { makeAutoObservable, runInAction } from "mobx";
import {
  getPageEtb,
  exportPatientTransferIn,
  exportPatientTransferOut,
  confirmTransferEtb
} from "../Patient/Services/PatientTransferService";
import "react-toastify/dist/ReactToastify.css";
import i18n from "i18n";
import { toast } from "react-toastify";

export default class PatientTransferStore {
  patientTransferList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  loadingInitial = false;
  searchObject = {};
  openConfirmTransfer = false;
  selectedPatientTransfer = null;

  //để update lại sô chưa tiếp nhận ở menu
  countConfirmTransfer = 1;

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleSetSearchObject = (obj) => {
    this.searchObject = {...obj}
  }

  updatePageData = () => {
    this.loadingInitial = true;

    let newSearchObj = this.getNewSearchObject()

    getPageEtb(newSearchObj).then((res) => {
      runInAction(() => {
        this.patientTransferList = res.data?.content;
        this.totalElements = res.data?.totalElements;
        this.totalPages = res.data?.totalPages;
      });
      this.setLoadingInitial(false);
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    })
  }

  getNewSearchObject = () => {
    return {
        ...this.searchObject,
        pageIndex: this.page,
        pageSize: this.rowsPerPage,
    }
  }

  resetSearchObject = () => {
    this.searchObject = {}
  }
  exportPatientTransferOut = () => {
    this.createExportRequest(exportPatientTransferOut, "DANH-SACH-CHUYEN-DI")
  }
  exportPatientTransferIn = () => {
    this.createExportRequest(exportPatientTransferIn, "DANH-SACH-CHUYEN-DEN")
  }
  createExportRequest = (api, fileName) => {
    api(this.searchObject).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    })
  }

  setOpenConfirmTransfer = state => {
    this.openConfirmTransfer = state;
  }

  setSelectedPatientTransfer = obj => {
    this.selectedPatientTransfer = obj
  }

  handleSubmitConfirmTransferPopup = (values, formHelper) => {
    // const obj = {
    //   ...this.selectedNotificationConfirmTransferItem,
    //   transferDate: item?.transferDate,
    //   receivedDate: item?.receivedDate,
    // };
    // if (!moment(obj?.receivedDate).isValid()) {
    //   toast.warn("Chưa nhập ngày tiếp nhận!");
    //   formHelper.setSubmitting(false);
    //   return;
    // }
    // if (obj?.transferDate && obj?.receivedDate) {
    //   if (moment(obj?.transferDate)
    //     .isAfter(moment(obj?.receivedDate), "d")) {
    //     toast.warn("Ngày tiếp nhận phải sau ngày chuyển đi!");
    //     formHelper.setSubmitting(false);
    //     return
    //   }
    // }

    return confirmTransferEtb(values).then((res) => {
      if (res?.data?.code === "-1") {
        toast.warn(i18n.t("toast.receivedByOther"));
        return res;
      }
      toast.success(i18n.t("toast.successReceived"));
    }).catch((error) => {
      console.log(error);
      toast.warning("toast.get_fail");
    }).finally(() => {
      this.setOpenConfirmTransfer(false);
      this.setSelectedPatientTransfer(null);
      this.updatePageData();
      this.updateCountConfirmTransfer();
    })
  }

  updateCountConfirmTransfer = () => this.countConfirmTransfer++

}
